var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfvalwijzerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "199.1px",
    height: "25.8px",
    viewBox: "0 0 199.1 25.8",
    style: {
      enableBackground: "new 0 0 199.1 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F1031;}\r\n\t.st1{fill:#108359;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,18.3h-7l-1.3,3.3H34l7.4-19.4h5.5l7.3,19.4h-5.4C48.8,21.5,47.6,18.3,47.6,18.3z M46.3,14.4l-2.2-6.3 L42,14.4H46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,12.3v9.2h-4.7v-9.2h-1.6V8.5h1.6V6.3c0-1.4,0.1-2.9,1.2-4.3c1.2-1.6,3-2.1,4.5-2.1c0.9,0,1.6,0.2,2.2,0.4 v4C63.7,4.1,63.1,4,62.9,4c-0.7,0-1.1,0.3-1.3,0.5C61.1,5.1,61,6.1,61,6.7v1.8h3.3v3.8L61,12.3L61,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.1,8.5l3.1,6.7l3.2-6.7h5.2l-6.8,13h-3.2l-6.7-13L71.1,8.5L71.1,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.4,8.5H98v13h-4.6v-1.4c-1.1,1.5-2.8,1.9-4,1.9c-1.4,0-3.1-0.4-4.7-2.1c-1.2-1.3-1.9-2.8-1.9-4.8 c0-2.4,1-4.2,2-5.2c1.1-1.1,2.8-1.8,4.7-1.8c2.1,0,3.3,1.1,3.9,1.7L93.4,8.5L93.4,8.5z M88.5,12.9c-0.6,0.6-0.9,1.5-0.9,2.1 c0,0.8,0.3,1.6,0.9,2.1c0.5,0.5,1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9c0.4-0.4,0.9-1.1,0.9-2.1c0-0.6-0.2-1.4-0.9-2.1 c-0.4-0.4-1.1-0.8-2.1-0.8C89.9,12,89.2,12.2,88.5,12.9L88.5,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.9,0v21.5h-4.6V0H105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,8.5l3.1,6.9l3.3-6.9h2.9l3.3,7.1l3.3-7.1h5.2l-6.8,13h-3.1l-3.3-7.2l-3.1,7.2h-3.1l-6.7-13H112.7 L112.7,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.6,0c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6S136.1,0,137.6,0z M139.9,8.5v13l0,0 c-2.6,0-4.6-2.1-4.6-4.7V8.5H139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.4,0c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6S143.9,0,145.4,0z M147.7,8.5v17.3l0,0 c-2.6,0-4.6-2.1-4.6-4.7V8.5L147.7,8.5L147.7,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.6,17.7h5.4v3.8h-13.2l6.1-9.2h-5.2V8.5h13L157.6,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.7,15.9H170c0,0.7,0.3,1.6,0.8,2.2c0.3,0.3,0.9,0.6,1.9,0.6c0.1,0,0.9,0,1.5-0.3c0.3-0.2,0.6-0.5,0.8-0.9 h4.4c-0.2,0.7-0.6,1.8-1.6,2.7s-2.5,1.8-5.3,1.8c-1.7,0-3.8-0.4-5.4-2c-0.8-0.8-1.9-2.4-1.9-4.9c0-2.2,0.8-3.9,1.9-5 c1.1-1.1,2.8-1.9,5.3-1.9c1.5,0,3.5,0.3,5,1.8c1.8,1.8,2.1,4,2.1,5.5L179.7,15.9L179.7,15.9z M175.4,13.2c-0.1-0.5-0.4-1.1-0.8-1.4 c-0.6-0.6-1.4-0.7-1.9-0.7c-0.8,0-1.4,0.2-1.9,0.7c-0.3,0.3-0.6,0.8-0.7,1.4H175.4L175.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.4,8.5h4.6v2.1c0.5-0.9,1.1-1.4,1.8-1.8c0.7-0.4,1.5-0.5,2.4-0.5c0.1,0,0.3,0,0.9,0.1v4.4 c-0.2-0.1-0.9-0.5-2-0.5c-0.6,0-1.4,0.1-2.1,0.7c-1,0.9-1.1,2.3-1.1,3v5.6h-4.6V8.5L182.4,8.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 196.5,
    cy: 18.9,
    r: 2.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,21.5L24.1,21.5L20.9,9.4c-0.8-3-3.6-5.1-6.7-5.1l0,0l3.2,12.1C18.2,19.4,21,21.5,24.1,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,21.5L0,21.5L3.2,9.4c0.8-3,3.6-5.1,6.7-5.1l0,0L6.7,16.4C5.9,19.4,3.1,21.5,0,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,4.3h-2.1c-1.2,0-2.1-0.9-2.1-2.1V0h2.1c1.2,0,2.1,0.9,2.1,2.1V4.3L14.2,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.1,21.5h2.1v2.1c0,1.2-0.9,2.1-2.1,2.1H9.9v-2.1C9.9,22.5,10.9,21.5,12.1,21.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfvalwijzerLogo);
export default __webpack_public_path__ + "static/media/afvalwijzer-logo.19c25b3f54278885f0f793d4569f9dc1.svg";
export { ForwardRef as ReactComponent };